module.exports = __webpack_public_path__ + "img/settings-user.69a736a3.svg";